exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".task-title-input[data-v-6037e6c3]{resize:none;overflow:hidden;border-radius:3px 0 0 3px;line-height:1.3em;width:200px}.task-title[data-v-6037e6c3]{height:auto;line-height:1.3em;width:190px!important;padding:6px 0 6px 12px}.task-completed-at[data-v-6037e6c3]{font-size:.6rem;line-height:1.2em;max-width:60px;white-space:normal}.task-details[data-v-6037e6c3]{font-size:12px;margin-right:4px}.subtask-title[data-v-6037e6c3]{line-height:1.2;color:#8997aa;font-family:Open Sans,sans-serif;font-size:14px;letter-spacing:0}", ""]);

// exports
